import {type ReactElement} from 'react'
import {useWatch} from 'react-hook-form'

import {useConfigContext} from '../../../../../utils/contexts/ConfigContext'
import type {InputType} from '../TextInput'
import {TextInput} from '../TextInput'

export const PhoneInput = (props: InputType): ReactElement => {
  const {name} = props
  const phone = useWatch({name})

  const {normalizePhone, getPhoneMask} = useConfigContext()

  const normalizePhoneInput = (phone: string): string => {
    let normalizedPhone = normalizePhone(phone)

    // Если первый символ - плюс, вырезаем его из строки
    if (normalizedPhone[0] === '+') {
      normalizedPhone = normalizedPhone.substring(1)
    }

    return normalizedPhone
  }

  return (
    <TextInput
      {...props}
      inputMode="tel"
      inputTransformationFunction={normalizePhoneInput}
      mask={getPhoneMask?.(phone)}
    />
  )
}
